import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './PaddedContainer.scss';

const PaddedContainer = ({ children, isRtl }) => {
  const classes = classNames({
    'padded-container': true,
    'padded-container--rtl': isRtl,
  });
  return (
    <div className={classes}>
      {children}
    </div>
  );
};

PaddedContainer.propTypes = {
  /** Children/ Elements */
  children: PropTypes.node,
  /** is right to left */
  isRtl: PropTypes.bool,
};

PaddedContainer.defaultProps = {
  children: <></>,
  isRtl: false,
};

export default PaddedContainer;
